import { OfferFragment } from '@occc/graphql';
import {
  makeCreateInStoreOnlyConstraintOperation,
  makeCreateOrderAheadOnlyConstraintOperation,
} from '@occc-app/offerHelpers/operations/constraints';
import { Operation } from '@occc-app/offerHelpers/types';

import {
  FulfillmentChannel,
  FulfillmentChannelFormValues,
} from './fulfillment-channel-constraint.types';

import { getInStoreOnlyConstraint } from '../in-store-only';
import { getOrderAheadOnlyConstraint } from '../order-ahead-only';
import { getPresenceConstraintOperations } from '../presence-constraint';

const withDeletionsFirst = (operations: Operation[]): Operation[] => [
  ...operations.filter(({ name }) => name === 'constraintDelete'),
  ...operations.filter(({ name }) => name !== 'constraintDelete'),
];

export const getFulfillmentChannelInitialValues = (
  offer: OfferFragment,
): FulfillmentChannelFormValues['fulfillmentChannelConstraint'] => {
  const isInStoreOnly = !!getInStoreOnlyConstraint(offer);
  const isOrderAheadOnly = !!getOrderAheadOnlyConstraint(offer);
  const isInStoreOnlySelected = isInStoreOnly && !isOrderAheadOnly;

  return {
    isEnabled: isInStoreOnly || isOrderAheadOnly,
    channel: isInStoreOnlySelected
      ? FulfillmentChannel.InStoreOnly
      : FulfillmentChannel.OrderAheadOnly,
  };
};

export const getFulfillmentChannelConstraintOperations = (
  offerId: string,
  offer: OfferFragment | undefined,
  values: FulfillmentChannelFormValues,
): Operation[] => {
  const { isEnabled, channel } = values.fulfillmentChannelConstraint;

  return withDeletionsFirst([
    ...getPresenceConstraintOperations(
      offerId,
      getOrderAheadOnlyConstraint(offer),
      isEnabled && channel === FulfillmentChannel.OrderAheadOnly,
      makeCreateOrderAheadOnlyConstraintOperation,
    ),
    ...getPresenceConstraintOperations(
      offerId,
      getInStoreOnlyConstraint(offer),
      isEnabled && channel === FulfillmentChannel.InStoreOnly,
      makeCreateInStoreOnlyConstraintOperation,
    ),
  ]);
};
